import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { take, catchError } from 'rxjs/operators';
import { StockOperation } from '../../models/stock-operation.model';
import { MOVEMENT_IN } from '../../models/product-stock-movement.model';
import { StockService } from '../../services/stock.service';
import { StockOperationValidatorService } from '../../validators/stock-operation-validator.service';

@Component({
    selector: 'app-goods-in',
    templateUrl: './goods-in.component.html',
    styleUrls: ['./goods-in.component.scss'],
    standalone: false
})
export class GoodsInComponent {

  operation: StockOperation = new StockOperation();

  operationType: string = MOVEMENT_IN;

  isError: boolean = false;
  isServerError: boolean = false;
  serverErrorMessage: string = '';

  constructor(private stockOperationValidator: StockOperationValidatorService,
    private stockService: StockService,
    private router: Router) { }

  /**
   * The whole batch goes up in one request because the backend runs it in a single
   * transaction. Posting line by line would allow a partial receipt.
   */
  onSubmit() {

    this.isError = false;
    this.isServerError = false;
    this.serverErrorMessage = '';

    if (this.stockOperationValidator.isValid(this.operation)) {
      this.stockService.goodsIn(this.operation)
      .pipe(take(1))
      .pipe(catchError((e) => {
        this.isServerError = true;
        this.serverErrorMessage = e.error && e.error.message ? e.error.message : '';
        return e;
      }))
      .subscribe((levels) => {
        this.router.navigate(['/warehousing/stock-movement-labels'], { state: { levels } });
      })
    } else {
      this.isError = true;
    }
  }
}
